export const defaultUrl = 'https://backend.production.bim.agiprod.agifly.cloud/api/v1/';
export const assetsUrl = 'https://backend.production.bim.agiprod.agifly.cloud';

export const getAllProjects = `${defaultUrl}web/project`
export const sendContactApi = `${defaultUrl}web/project/contact`
